import { ILocales } from "@/config/i18n";

export function getLanguageCodeFromPathname(
  pathname: string,
  locales: string[],
  defaultLocale: ILocales
): ILocales {
  if (!pathname) {
    console.warn("getLanguageCodeFromPathname - pathname undefined");
    return defaultLocale;
  }

  const parts = pathname.split("/").filter((part) => part !== ""); // Remove empty parts

  if (parts.length > 0 && locales.includes(parts[0])) {
    // Check if the first part is a valid language code
    return parts[0] as ILocales;
  }

  return defaultLocale; // Return the default language
}
